import { __decorate, __extends, __metadata } from "tslib";
import { UserEventBase } from './UserEvent';
import NeoModel from '../NeoModel';
import { StringLength } from '../../Validation/Decorators';
var ReasonedUserEvent = /** @class */ (function (_super) {
    __extends(ReasonedUserEvent, _super);
    function ReasonedUserEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReasonedUserEvent_1 = ReasonedUserEvent;
    ReasonedUserEvent.None = function () {
        return new ReasonedUserEvent_1();
    };
    var ReasonedUserEvent_1;
    __decorate([
        StringLength(255),
        __metadata("design:type", String)
    ], ReasonedUserEvent.prototype, "reason", void 0);
    ReasonedUserEvent = ReasonedUserEvent_1 = __decorate([
        NeoModel
    ], ReasonedUserEvent);
    return ReasonedUserEvent;
}(UserEventBase));
export { ReasonedUserEvent };
